export const APP_NAME = 'Floor Plan';

export const FLOORPLAN_TAGLINE =
  'Draw floor plans quickly in the browser. No CAD required. Add rooms, symbols, and export for credits.';

export const FLOORPLAN_FEATURES = [
  { title: 'Draw Rooms', description: 'Drag to create room boxes. Auto-labels, dimensions, and area calculation.' },
  { title: 'Symbol Library', description: 'Doors, windows, furniture, fixtures. Click to place, resize, rotate.' },
  { title: 'Export Anywhere', description: 'PNG, PDF, or SVG. Use credits for high-res export.' },
];
